<template>
  <AdminModal :title="`Restablecer contraseña · ${user.name || user.email}`" @close="$emit('close')">
    <template v-if="!result">
      <p class="ad-note">
        Se generará un enlace para que <strong>{{ user.email }}</strong> cree una contraseña nueva y se le enviará por correo.
        Tú no ves ni fijas la contraseña. Su contraseña actual sigue funcionando hasta que use el enlace; al usarlo se cierran todas sus sesiones.
      </p>
      <form class="ad-field" @submit.prevent="submit">
        <label for="rp-pass">Confirma tu contraseña de superadmin</label>
        <input id="rp-pass" v-model="password" type="password" class="ad-input" autocomplete="current-password" autofocus />
      </form>
      <p v-if="error" class="ad-error">{{ error }}</p>
    </template>
    <template v-else>
      <p class="ad-note">Enlace generado. También se envió a {{ user.email }}; compártelo tú solo si no le llega.</p>
      <div class="ad-linkbox">
        <input ref="input" class="ad-input" :value="result.resetUrl" readonly @focus="$event.target.select()" />
        <button type="button" class="ad-btn ad-btn--primary" @click="copy">{{ copied ? 'Copiado' : 'Copiar' }}</button>
      </div>
      <p class="ad-hint" style="margin-top: 8px">Vence {{ formatDateTime(result.expiresAt) }} y solo sirve una vez. Un enlace nuevo reemplaza a este.</p>
    </template>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">{{ result ? 'Cerrar' : 'Cancelar' }}</button>
      <button v-if="!result" type="button" class="ad-btn ad-btn--primary" :disabled="busy || !password" @click="submit">
        {{ busy ? 'Generando…' : 'Generar enlace' }}
      </button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref } from 'vue'
import AdminModal from './AdminModal.vue'
import { resetUserPassword } from '@/services/superadmin'
import { errorText, formatDateTime } from './adminFormat'

const props = defineProps({ user: { type: Object, required: true } })
const emit = defineEmits(['close', 'done'])

const password = ref('')
const busy = ref(false)
const error = ref('')
const result = ref(null)
const input = ref(null)
const copied = ref(false)

async function submit() {
  if (!password.value || busy.value) return
  busy.value = true
  error.value = ''
  try {
    result.value = await resetUserPassword(props.user.kind, props.user.id, password.value)
    password.value = ''
    emit('done')
  } catch (err) {
    error.value = errorText(err)
  } finally {
    busy.value = false
  }
}

async function copy() {
  try {
    await navigator.clipboard.writeText(result.value.resetUrl)
  } catch {
    input.value?.select()
    document.execCommand('copy')
  }
  copied.value = true
  setTimeout(() => { copied.value = false }, 1800)
}
</script>